import React, { useState } from "react";
import { Button } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import theme from "../../../themes/theme";
import defaultImg from "../../../images/image 5.png";

const ImageUploadPreview = ({ onImageChange, imageUrl }) => {
  const [image, setImage] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    setImage(file);
    onImageChange(file);
  };

  return (
    <div>
      {defaultImg && !image ? <img src={defaultImg} alt="default" style={{ width: "100%", height: "150px" }} /> : image && <img src={URL.createObjectURL(image)} alt="course" style={{ width: "100%", height: "150px" }} />}
      <label htmlFor="image-upload" className="image-upload-label">
        <ThemeProvider theme={theme}>
          <Button component="span" variant="contained">
            Upload Image
          </Button>
        </ThemeProvider>
      </label>
      <input id="image-upload" type="file" name="image" accept="image/jpeg" onChange={handleImageChange} style={{ display: "none" }} />
    </div>
  );
};

export default ImageUploadPreview;
